import { token } from '@atlaskit/tokens';
import Z_INDEX from '@databases/layout/z-index';
import { type CSSProperties } from 'react';

const PINNED_LEADING_SHADOW_CLIP_OUTSET_PX = 16;
const PINNED_LEADING_SHADOW_HOST_WIDTH_PX = 8;
const PINNED_LEADING_SURFACE_GAP_COVER_WIDTH_PX = 3;
const PINNED_LEADING_INTERNAL_EDGE_WIDTH_PX = 1;

const PINNED_LEADING_BOUNDARY_CELL_SHADOW_STYLE: CSSProperties = {
  position: 'absolute',
  top: 0,
  right: 0,
  width: `${PINNED_LEADING_SHADOW_HOST_WIDTH_PX}px`,
  bottom: 0,
  height: '100%',
  pointerEvents: 'none',
  boxShadow: token('elevation.shadow.overflow', '0 0 8px #091E4229'),
  clipPath: getPinnedLeadingShadowClipPath(),
  zIndex: Z_INDEX.TABLE_VIEW_DROP_INDICATOR,
};

const PINNED_LEADING_SURFACE_GAP_COVER_STYLE: CSSProperties = {
  position: 'absolute',
  top: 0,
  bottom: 0,
  // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- This covers the exact collapsed table border gap between adjacent sticky cells.
  left: `-${PINNED_LEADING_SURFACE_GAP_COVER_WIDTH_PX}px`,
  width: `${PINNED_LEADING_SURFACE_GAP_COVER_WIDTH_PX}px`,
  pointerEvents: 'none',
  backgroundColor: token('elevation.surface', '#FFFFFF'),
  borderRight: `${PINNED_LEADING_INTERNAL_EDGE_WIDTH_PX}px solid ${token(
    'color.border',
    '#091E4224'
  )}`,
  zIndex: 1,
};

const PINNED_LEADING_HEADER_SURFACE_GAP_COVER_STYLE: CSSProperties = {
  ...PINNED_LEADING_SURFACE_GAP_COVER_STYLE,
  backgroundColor: token('elevation.surface.sunken', '#F7F8F9'),
};

export function getPinnedLeadingShadowClipPath(): string {
  return `inset(0 -${PINNED_LEADING_SHADOW_CLIP_OUTSET_PX}px 0 ${
    PINNED_LEADING_SHADOW_HOST_WIDTH_PX - 1
  }px)`;
}

export function getPinnedLeadingBoundaryShadowStyle({
  height,
}: {
  height: number;
}): CSSProperties {
  return {
    position: 'absolute',
    top: 0,
    right: 0,
    width: `${PINNED_LEADING_SHADOW_HOST_WIDTH_PX}px`,
    height: `${height}px`,
    pointerEvents: 'none',
    boxShadow: token('elevation.shadow.overflow', '0 0 8px #091E4229'),
    clipPath: getPinnedLeadingShadowClipPath(),
    zIndex: Z_INDEX.TABLE_VIEW_DROP_INDICATOR,
  };
}

export function getPinnedLeadingBoundaryCellShadowStyle(): CSSProperties {
  return PINNED_LEADING_BOUNDARY_CELL_SHADOW_STYLE;
}

export function getPinnedLeadingSurfaceGapCoverStyle(): CSSProperties {
  return PINNED_LEADING_SURFACE_GAP_COVER_STYLE;
}

export function getPinnedLeadingHeaderSurfaceGapCoverStyle(): CSSProperties {
  return PINNED_LEADING_HEADER_SURFACE_GAP_COVER_STYLE;
}
